"use strict";

exports.__esModule = true;
var _DashboardRoutes = require("./DashboardRoutes");
Object.keys(_DashboardRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardRoutes[key]) return;
  exports[key] = _DashboardRoutes[key];
});